import React, { useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import API, { setAuthToken, setOrthancAuthCookie, setAccessToken } from '../../services/api.ts';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';
import styles from './Login.module.css';
import { useNavigate, Link } from 'react-router-dom';

const Login = ({ setIsAuthenticated }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [domain, setDomain] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const response = await API.post('/accounts/login/', { username, password, domain });
            const { access, refresh } = response.data;

            setAccessToken(access);
            localStorage.setItem('refresh_token', refresh);
            localStorage.setItem('username', username);

            setAuthToken(access);
            setIsAuthenticated(true);

            // Set orthanc_auth cookie for OHIF viewer auth via nginx
            setOrthancAuthCookie(access);

            toast.success('Login successful! Redirecting...');
            setTimeout(() => navigate('/Dashboard'), 3000);

        } catch (err) {
            toast.error('Invalid credentials. Please try again.');
        }
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    return (
        <div className={`${styles.login} d-flex flex-column align-items-center justify-content-center`}>
            {/* Back to landing */}
            <Link to="/" className="position-absolute top-0 start-0 m-3 btn btn-outline-secondary btn-sm">
                <i className="fa fa-arrow-left me-1"></i> Back
            </Link>

            {/* Toast Container */}
            <ToastContainer autoClose={3000} />

            {/* Logo Section */}
            <div className="d-flex align-items-center justify-content-center gap-4 mb-4">
                <div className={`${styles.bgImage1}`}>
                    <img src="/assets/MountSinaiLogo.png" alt="logo" className="img-fluid" />
                </div>
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-md-4 col-lg-6 mx-auto">
                        <div className="row">
                            <div className="col text-start">
                                <h3 className={`${styles.loginHeading} mb-4`}>Welcome back!</h3>
                            </div>
                        </div>
                        <form onSubmit={handleLogin} className="was-validated">
                            {process.env.REACT_APP_LDAP_ENABLED === 'true' && (
                                <div className="mb-3">
                                    <div className="input-group">
                                        <span className="input-group-text" id={styles.inputGroupText}>
                                            <i className="fa fa-building"></i>
                                        </span>
                                        <select
                                            className="form-select"
                                            value={domain}
                                            onChange={(e) => setDomain(e.target.value)}
                                        >
                                            <option value="">Local Account</option>
                                            <option value="mssm">MSSM</option>
                                            <option value="mountsinai">Mount Sinai</option>
                                        </select>
                                    </div>
                                </div>
                            )}
                            <div className="mb-3">
                                <div className="input-group">
                                    <span className="input-group-text" id={styles.inputGroupText}>
                                        <i className="fa fa-user"></i>
                                    </span>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Username"
                                        value={username}
                                        onChange={(e) => setUsername(e.target.value)}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="mb-3">
                                <div className="input-group">
                                    <span className="input-group-text" id={styles.inputGroupText}>
                                        <i className="fa fa-key"></i>
                                    </span>
                                    <input
                                        type={showPassword ? 'text' : 'password'}
                                        className="form-control"
                                        placeholder="Password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        required
                                    />
                                    <span
                                        className="input-group-text"
                                        id={styles.eye}
                                        style={{cursor: 'pointer'}}
                                        onClick={togglePasswordVisibility}
                                    >
                                        <i className={`fa ${showPassword ? 'fa-eye' : 'fa-eye-slash'}`}/>
                                    </span>
                                </div>
                            </div>
                            <div className="d-grid gap-2">
                                <button type="submit" className="btn btn-danger">
                                    <i className="fa fa-sign-in"></i> Login
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
